//
//
//
//

export default {
  name: 'EmptyLayout'
}
